import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Filter from "../components/Filter";

export default class PageQuestionnaire {
    constructor(dom) {
        this.dom = dom;
        window.addEventListener("resize", () => this.resize());

        this.loading = false

        this.programmeList = JSON.parse(this.dom.querySelector(".questionnaire-form").dataset.programmeList);
        console.log(this.programmeList);
        
        this.customWpform();
    }

    async init() {
        this.initResponsiveHelper();
    }

    customWpform() {
        let programmeSlugInput = this.dom.querySelector(".wpforms-field.ccf-programme-slug input");
        let programmeLocationInput = this.dom.querySelector(".wpforms-field.ccf-programme-location input");
        let programmeDateStringInput = this.dom.querySelector(".wpforms-field.ccf-programme-date-string input");
        let eventFullNameInput = this.dom.querySelector(".wpforms-field.ccf-event-full-name input");
        let nameField = this.dom.querySelector(".wpforms-field.ccf-programme-name");
        let nameField_input = nameField.querySelector("input");
        let dateField = this.dom.querySelector(".wpforms-field.ccf-programme-date");
        dateField.style.display = "none";

        // Add Select to nameField
        let select = document.createElement("select");
        select.name = "wpforms[fields][ccf-programme-name]";
        select.id = "wpforms-ccf-programme-name";
        select.required = true;

        // let defaultOption = document.createElement("option");
        // defaultOption.value = "";
        // defaultOption.text = "Please select a programme";
        // select.appendChild(defaultOption);

        this.programmeList.forEach(programme => {
            let option = document.createElement("option");
            // option.value = programme.ID;
            option.value = programme.slug;
            
            let temp = document.createElement("div");
            temp.innerHTML = programme.title;
            option.text = temp.textContent;

            select.appendChild(option);
        });

        select.addEventListener("change", () => {
            nameField_input.value = select.options[select.selectedIndex].text;
            programmeSlugInput.value = select.value;
            programmeLocationInput.value = "";
            programmeDateStringInput.value = "";
            
            // Handle date field
            if (select.value == "") {
                dateField.style.display = "none";
                // clear date field value
                let dateField_input = dateField.querySelector("input");
                if(dateField_input) dateField_input.value = "";
                let existingCustom = dateField.querySelector(".custom-date-field");
                if(existingCustom) existingCustom.remove();
                return;
            }
            if (select.value == "not-applicable") {
                dateField.style.display = "none";
                let dateField_input = dateField.querySelector("input");
                if(dateField_input) dateField_input.value = "not-applicable";
                let existingCustom = dateField.querySelector(".custom-date-field");
                if(existingCustom) existingCustom.remove();
                return;
            } else {
                dateField.style.display = "block";
            }

            let selectedProgramme = this.programmeList.find(p => p.slug == select.value);
            if(selectedProgramme) {
                dateField.classList.remove("wpforms-has-error");
                let dateField_input = dateField.querySelector("input");
                let err_msg = dateField.querySelectorAll(".wpforms-error");
                let existingCustom = dateField.querySelector(".custom-date-field");
                if(existingCustom) existingCustom.remove();
                if(err_msg) err_msg.forEach(msg => msg.remove());
                if(dateField_input) { 
                    dateField_input.value = "";
                    dateField_input.style.display = "none";
                }

                if (selectedProgramme.questionnaire_date_field_type == "select_options") {
                    let dateSelect = document.createElement("select");
                    // dateSelect.name = "wpforms[fields][ccf-programme-date]";
                    dateSelect.className = "custom-date-field";
                    dateSelect.required = true;
                    
                    // let defaultOption = document.createElement("option");
                    // defaultOption.value = "";
                    // defaultOption.text = "Please select a date";
                    // dateSelect.appendChild(defaultOption);

                    if (selectedProgramme.select_options) {
                        selectedProgramme.select_options.forEach(opt => {
                            let option = document.createElement("option");
                            if (typeof opt == "object") {
                                option.value = opt.value;
                                option.text = opt.label;
                                option.dataset.location = opt.location || "";
                            } else { 
                                option.value = opt;
                                option.text = opt;
                            }
                            dateSelect.appendChild(option);
                        });
                    }

                    dateSelect.addEventListener("change", () => {
                        if(dateField_input) dateField_input.value = dateSelect.value;
                        if(eventFullNameInput) eventFullNameInput.value = dateSelect.options[dateSelect.selectedIndex].text;

                        programmeLocationInput.value = dateSelect.options[dateSelect.selectedIndex].dataset.location || "";
                        programmeDateStringInput.value = dateSelect.value;
                    });
                    dateField.appendChild(dateSelect);

                } else if (selectedProgramme.questionnaire_date_field_type == "date_picker") {
                    let dateInput = document.createElement("input");
                    dateInput.type = "text";
                    // dateInput.name = "wpforms[fields][ccf-programme-date]";
                    dateInput.className = "custom-date-field";
                    dateInput.required = true;
                    dateField.appendChild(dateInput);
                    
                    let config = {
                        controls: ['calendar'],
                        display: 'anchored',
                        dateFormat: 'DD/MM/YYYY',
                        onChange: (event, inst) => {
                            if(dateField_input) {
                                let date = inst.getVal(true);
                                dateField_input.value = date ? mobiscroll.formatDate('DD/MM/YYYY', date) : "";
                                programmeDateStringInput.value = dateField_input.value;
                                if (date && selectedProgramme.select_options) {
                                    let selectedOption = selectedProgramme.select_options.find(opt => {
                                        let d = opt.date_Ymd;
                                        let optDate = new Date(d.substring(0,4), parseInt(d.substring(4,6))-1, d.substring(6,8));
                                        return optDate.getTime() === date.getTime();
                                    });
                                    if (selectedOption) {
                                        programmeLocationInput.value = selectedOption.location || "";
                                    } else {
                                        programmeLocationInput.value = "";
                                    }
                                }
                            }
                        }
                    };

                    if (selectedProgramme.select_options && selectedProgramme.select_options.length > 0) {
                        config.valid = selectedProgramme.select_options.map(date => {
                            let date_Ymd = date.date_Ymd;
                            return new Date(date_Ymd.substring(0,4), parseInt(date_Ymd.substring(4,6))-1, date_Ymd.substring(6,8));
                        });
                    }

                    mobiscroll.datepicker(dateInput, config);
                } else {
                    if (dateField_input) {
                        dateField_input.style.display = "block";
                    }
                }
            }
        });

        nameField.appendChild(select);
        nameField_input.style.display = "none";

        this.dom.querySelector(".questionnaire-form").style.opacity = 1;
    }

    initResponsiveHelper() {

    }

    resize() {
    }

    destory() {

    }
}
